import { render } from "./Analytics.vue?vue&type=template&id=0fb516be&scoped=true&ts=true&lang=pug"
import script from "./Analytics.vue?vue&type=script&lang=ts"
export * from "./Analytics.vue?vue&type=script&lang=ts"

import "./Analytics.vue?vue&type=style&index=0&id=0fb516be&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fb516be"]])

export default __exports__